/* @flow */
import { ApolloLink } from 'apollo-link';

function developmentLog(operation, result, ellapsed) {
  console.groupCollapsed(`%c🚀 GQL - ${operation.operationName} - ${ellapsed}ms`, 'color: #285f96');
  console.log('OPERATION', operation);
  console.log('RESULT', result);
  console.groupEnd();
}

function productionLog(operation) {
  console.debug('GQL query', {
    name: operation.operationName,
    variables: operation.variables,
  });
}

function safe(op) {
  try {
    op();
  } catch (e) {
    console.warn(e);
    console.error('could not log operation');
  }
}

class LogQueryLink extends ApolloLink {
  request(operation: *, forward: *) {
    const startTime = new Date();

    if (!__DEV__) {
      safe(() => productionLog(operation));
    }

    return forward(operation).map(result => {
      if (__DEV__) {
        safe(() => developmentLog(operation, result, new Date().getTime() - startTime));
      }

      return result;
    });
  }
}

export { LogQueryLink };
